// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"31fa2146","141":"49fe6093","150":"8193cca3","350":"af3ba1d3","443":"c8b7bbf1","897":"09ae3d60","965":"74899454","998":"656e77be"}[chunkId] + ".chunk.css";
};